import {createAction, props} from '@ngrx/store';
import {Listing} from '../../shared/models/listing.interface';
import {ListingPrivate} from '../../shared/models/listingPrivate.interface';

export const addListingToCache = createAction('[Listing] adding listing to cache', props<{ listing: Listing }>());
export const addListingPrivateToCache = createAction('[ListingPrivate] adding listingPrivate to cache', props<{ listingPrivate: ListingPrivate }>());
